export default __webpack_public_path__ + "static/media/menu_bg.19004916.png";